export enum TbcEnum {
  TBC = "TBC",
}
